import React from 'react'

import { NewsletterSignup } from 'component-library/banners/NewsletterSignup/NewsletterSignup'
import { createRegisterableComponent } from 'common/routing/page-definition'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export interface NewsletterSignupRouteProps {
    text: string
    buttonLabel: string
    verticalSpacing?: keyof ThemeMargins
}

export const NewsletterSignupRegistration = createRegisterableComponent(
    'newsletter-signup',
    (props: NewsletterSignupRouteProps, services) => (
        <NewsletterSignup {...props} api={services.config.contentApi} onEvent={services.onEvent} />
    )
)
